module["exports"] = [
  "zu",
  "von",
  "vom",
  "von der"
];
